var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#334B49"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12758_11662",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12758_11662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20C17.25 20 18.3127 19.5627 19.188 18.688C20.0627 17.8127 20.5 16.75 20.5 15.5C20.5 14.25 20.0627 13.1873 19.188 12.312C18.3127 11.4373 17.25 11 16 11C14.75 11 13.6873 11.4373 12.812 12.312C11.9373 13.1873 11.5 14.25 11.5 15.5C11.5 16.75 11.9373 17.8127 12.812 18.688C13.6873 19.5627 14.75 20 16 20ZM16 18.2C15.25 18.2 14.6127 17.9373 14.088 17.412C13.5627 16.8873 13.3 16.25 13.3 15.5C13.3 14.75 13.5627 14.1123 14.088 13.587C14.6127 13.0623 15.25 12.8 16 12.8C16.75 12.8 17.3877 13.0623 17.913 13.587C18.4377 14.1123 18.7 14.75 18.7 15.5C18.7 16.25 18.4377 16.8873 17.913 17.412C17.3877 17.9373 16.75 18.2 16 18.2ZM16 23C13.5667 23 11.35 22.3207 9.35 20.962C7.35 19.604 5.9 17.7833 5 15.5C5.9 13.2167 7.35 11.3957 9.35 10.037C11.35 8.679 13.5667 8 16 8C18.4333 8 20.65 8.679 22.65 10.037C24.65 11.3957 26.1 13.2167 27 15.5C26.1 17.7833 24.65 19.604 22.65 20.962C20.65 22.3207 18.4333 23 16 23ZM16 21C17.8833 21 19.6127 20.504 21.188 19.512C22.7627 18.5207 23.9667 17.1833 24.8 15.5C23.9667 13.8167 22.7627 12.479 21.188 11.487C19.6127 10.4957 17.8833 10 16 10C14.1167 10 12.3873 10.4957 10.812 11.487C9.23733 12.479 8.03333 13.8167 7.2 15.5C8.03333 17.1833 9.23733 18.5207 10.812 19.512C12.3873 20.504 14.1167 21 16 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.4d0ad88cc2bd63c7c3e423793db0de8d.svg";
export { ForwardRef as ReactComponent };